// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { usePendingIncomingPayment, getSafeCipUrl, redirectIfCheckForConfirmationIsEnabled } from '@tectonics/prs/incoming-payment';
import { Button } from '../../../atoms';

export function SaveCipCodeAsPdf(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const cipUrl = getSafeCipUrl(incomingPayment);

  return (
    <LinkButton type="primary" as="a" href={`${cipUrl}&format=pdf`} target="_blank" data-test-id="pagoefectivo-pdf-button" onClick = { () => redirectIfCheckForConfirmationIsEnabled(incomingPayment) } >
      GUARDAR VOUCHER EN PDF
    </LinkButton>
  );
}

const LinkButton = styled(Button)`
  width: 100%;
  margin-top: 16px;
  background-color: ${props => props.theme.colors.new_primary[900]};
  color: #fff;
  font-size: 17px;
  border-radius: 5px;
`;
